/**
 * SKU表单 - 图片视频管理（紧凑优化版）
 * 职责: 产品图片和视频的上传管理
 */

import React, { useState } from 'react';
import { Upload, Image, Button, message, Empty, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';

export const SKUFormMediaFields: React.FC = () => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    const handlePreview = async (file: UploadFile) => {
        setPreviewImage(file.url || file.thumbUrl || '');
        setPreviewOpen(true);
    };

    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传</div>
        </div>
    );

    return (
        <>
            <Divider orientation="left" style={{ margin: '12px 0 8px', fontWeight: 600 }}>产品图片</Divider>

            <Upload
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                beforeUpload={(file) => {
                    const isImage = file.type.startsWith('image/');
                    if (!isImage) {
                        message.error('只能上传图片文件！');
                    }
                    const isLt5M = file.size / 1024 / 1024 < 5;
                    if (!isLt5M) {
                        message.error('图片大小不能超过 5MB!');
                    }
                    return false; // 阻止自动上传
                }}
                accept="image/*"
            >
                {fileList.length >= 10 ? null : uploadButton}
            </Upload>

            {previewImage && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                    }}
                    src={previewImage}
                />
            )}

            {fileList.length === 0 && (
                <Empty
                    description="暂无图片"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    style={{ margin: '12px 0' }}
                />
            )}

            <Divider orientation="left" style={{ margin: '24px 0 8px', fontWeight: 600 }}>产品视频</Divider>

            <Upload
                listType="picture"
                accept="video/*"
                beforeUpload={(file) => {
                    const isVideo = file.type.startsWith('video/');
                    if (!isVideo) {
                        message.error('只能上传视频文件！');
                    }
                    const isLt50M = file.size / 1024 / 1024 < 50;
                    if (!isLt50M) {
                        message.error('视频大小不能超过 50MB!');
                    }
                    return false;
                }}
                maxCount={3}
            >
                <Button icon={<PlusOutlined />} size="small">上传视频</Button>
            </Upload>
            <div style={{ marginTop: 8, color: '#999', fontSize: 12 }}>
                支持 MP4、MOV 格式，单个文件不超过 50MB，最多3个视频
            </div>
        </>
    );
};
